/* eslint-disable func-names */
import React, { Component } from "react";
import PropTypes from "prop-types";
import Feature from "./Feature.jsx";

const featureId = {
  2: "Display Number",
  3: "PreConnection Greeting",
  4: "Whisper Announcement",
  5: "Voicemail",
  6: "Call Recording",
  7: "Queue",
  8: "Midcall Transfer",
  11: "Missed Call Alerts",
  12: "OOH Voicemail",
  14: "Disaster Recovery",
  15: "Date Exception",
  17: "Caller Exception",
  9: "Fax to Email",
  10: "Interactive Menu",
  13: "Fallback Message",
  16: "Area Plan",
  18: "Out Of Hours",
};

const linkedServices = {};

export default class Summary extends Component {
  abortController = new AbortController();

  constructor(props, context) {
    super(props, context);
    this.state = {
      moduleList: [],
      serviceNumbers: [],
    };
  }

  updateState = (dataObject) =>
    this.setState({
      serviceData: dataObject,
      moduleList: dataObject.moduleList,
      serviceName: dataObject.service.name,
      timeZone: dataObject.timeZone,
      serviceNumbers: dataObject.ddiList,
    });

  componentDidMount = () => {
    if (linkedServices[this.props.moduleGroupId]) {
      this.updateState(linkedServices[this.props.moduleGroupId]);
    } else {
      fetch(`/services/load_summary_json?id=${this.props.moduleGroupId}`, {
        signal: this.abortController.signal,
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          return res.json();
        })
        .then((data) => {
          if (data.response.status === "OK") {
            linkedServices[this.props.moduleGroupId] =
              data.response.moduleGroupList;
            this.updateState(data.response.moduleGroupList);
          } else {
            this.setState({
              serviceData: "Error",
              serviceName: "Error Loading Service",
            });
          }
        })
        .catch(() => {
          this.setState({
            serviceData: "Error",
            serviceName: "Error Loading Service",
          });
        });
    }
  };

  getDisplayTimeZone = (timeZoneId) => {
    const timeZoneList = document.querySelector("#timeZoneList").val();
    const timezones = timeZoneList
      .substring(1, timeZoneList.length - 1)
      .split(",");
    const timezone = timezones.find(
      (tz) => tz.split("=")[0].trim() === timeZoneId,
    );
    return timezone ? timezone.split("=")[1] : timeZoneId;
  };

  componentWillUnmount = () => {
    this.abortController.abort();
  };

  render = () => {
    const centreStyle = { textAlign: "center" };
    const greenText = { color: "#00b108" };

    const servicetype = (
      <Feature
        featureName="Service Type"
        displayValue={this.state.serviceName}
      />
    );

    const numberDisplay = this.state.serviceNumbers.map((o, i) => (
      <div key={i}>{o.ddi}</div>
    ));
    const numbersOnService =
      this.state.serviceData && this.state.serviceNumbers.length > 0 ? (
        <Feature
          featureName="Number(s) on Service"
          displayValue={numberDisplay}
        />
      ) : (
        ""
      );

    const timeZone = this.state.timeZone ? (
      <Feature
        featureName="Time Zone"
        displayValue={this.getDisplayTimeZone(this.state.timeZone.timeZoneId)}
      />
    ) : (
      ""
    );
    const destinationMap = this.state.moduleList
      .filter((entry) => entry.moduleType.id === 1)
      .map(function (o, i) {
        const destList = o.destinationList.map((obj, idx) => (
          <div key={idx}>
            {obj.destinationType === 3 ? obj.agentProfileName : obj.destination}
          </div>
        ));
        return [
          <Feature key={i} featureName={o.name} displayValue={destList} />,
          <Feature
            key={o.id}
            featureName="Time Of Day"
            displayValue={o.todPreset ? "Set" : "Not Set"}
          />,
        ];
      });
    const listMap = this.state.moduleList
      .filter((entry) => entry.moduleType.id !== 1)
      .map((o, i) => (
        <Feature
          key={i}
          featureName={featureId[o.moduleType.id]}
          displayValue="ON"
          style={greenText}
        />
      ));
    if (this.state.serviceData) {
      return (
        <div>
          <fieldset className="linked-service-summary">
            {servicetype}
            {numbersOnService}
            {destinationMap}
            {timeZone}
            {listMap}
          </fieldset>
        </div>
      );
    }
    return (
      <div>
        <div style={centreStyle}>
          <img src={"/_client/images/global/ui-loader-1.gif"} />
        </div>
      </div>
    );
  };
}

Summary.propTypes = {
  moduleGroupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
